/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { HiCheck } from "react-icons/hi";
import { Pagination } from "../components/Pagination";

const MyAdminComponent = ({
  page,
  count,
  admins,
  setPage,
  setTotal,
  pageSize,
  setPageSize,
  currentYear,
  currentMonth,
  currentAdmin,
  loadStatistics,
  setCurrentAdmin,
  setLocalSetStats,
  getAllByAdminCompanyId,
}: any) => {
  const getInitials = (a = "", b = "") => {
    const fi = String(a || "").trim().charAt(0).toUpperCase();
    const li = String(b || "").trim().charAt(0).toUpperCase();
    return (fi + li) || "A";
  };

  return (
    <div className="flex flex-col gap-3">
      {/* List */}
      <div className="flex max-h-[460px] flex-col gap-1.5 overflow-y-auto pr-0.5">
        {admins ? (
          admins.length === 0 ? (
            <div className="rounded-xl border border-dashed border-gray-300 bg-white p-6 text-center">
              <p className="text-xs font-semibold text-gray-900">No team members</p>
              <p className="mt-0.5 text-[11px] text-gray-500">
                Nothing to display yet.
              </p>
            </div>
          ) : (
            admins.map((adm: any, idx: number) => {
              const selected = idx === currentAdmin;
              const fullName = `${String(adm?.first_name || "")} ${String(
                adm?.last_name || ""
              )}`.trim();
              return (
                <button
                  key={idx}
                  type="button"
                  onClick={() => {
                    setCurrentAdmin(idx);
                    setLocalSetStats(null);
                    setTotal(0);
                    loadStatistics({
                      year: currentYear,
                      month: currentMonth,
                      admin: adm?.admin_id,
                    });
                  }}
                  className={[
                    "group flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left transition",
                    "focus:outline-none focus-visible:ring-2 focus-visible:ring-brand",
                    selected
                      ? "bg-gray-900 text-white"
                      : "text-gray-800 hover:bg-gray-50",
                  ].join(" ")}
                >
                  <div
                    className={[
                      "flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-xs font-semibold",
                      selected
                        ? "bg-white/15 text-white ring-1 ring-white/20"
                        : "bg-gray-100 text-gray-700",
                    ].join(" ")}
                    aria-hidden
                  >
                    {getInitials(adm?.first_name, adm?.last_name)}
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-medium">
                      {fullName || "—"}
                    </p>
                    <p
                      className={`truncate text-[11px] ${
                        selected ? "text-white/70" : "text-gray-500"
                      }`}
                    >
                      {adm?.email || "View statistics"}
                    </p>
                  </div>
                  {selected ? (
                    <HiCheck className="h-4 w-4 shrink-0 text-white" aria-hidden />
                  ) : (
                    <span
                      className="h-1.5 w-1.5 shrink-0 rounded-full bg-gray-300"
                      aria-hidden
                    />
                  )}
                </button>
              );
            })
          )
        ) : (
          Array.from({ length: 6 }).map((_, i) => (
            <div
              key={`sk-${i}`}
              className="flex animate-pulse items-center gap-3 rounded-xl border border-gray-200 bg-white px-3 py-2.5"
            >
              <div className="h-9 w-9 rounded-full bg-gray-200" />
              <div className="flex-1">
                <div className="mb-1.5 h-3 w-40 rounded bg-gray-200" />
                <div className="h-2.5 w-28 rounded bg-gray-100" />
              </div>
            </div>
          ))
        )}
      </div>

      {/* Pagination */}
      <div className="border-t border-gray-100 pt-3">
        <Pagination
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          total_items={count}
          callbackFunction={(p: any, size: any) => {
            getAllByAdminCompanyId(p, size);
          }}
        />
      </div>
    </div>
  );
};

export default MyAdminComponent;
